import { Button as ButtonAntd } from 'antd';
import styled from 'styled-components';

export const BtnSuccess = styled(ButtonAntd)`
  color: #fff !important;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    #0ce536;
  border: 1px solid #17b635 !important;

  &:hover,
  &:focus,
  &:active {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
      #12ff40;
  }
`;

export const BtnSuccessOutline = styled(ButtonAntd)`
  &,
  &:focus {
    background: transparent;
    color: #0ce536;
    border-color: #137f28;
  }

  &:hover,
  &:active {
    background: #137f28;
    color: #fff;
    border-color: #000;
  }
`;

export const BtnLink = styled(ButtonAntd)`
  &,
  &:focus {
    color: #55ed73;
  }

  &:hover,
  &:active {
    color: #59ec76;
  }
`;

export const BtnExportCsv = styled(ButtonAntd)`
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.65) !important;

  &,
  span {
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  }

  &:hover,
  &:focus,
  &:active {
    border: 1px dashed #17b635 !important;
    span {
      color: #17b635;
    }
  }
`;
